import { gql } from '@apollo/client';

export const DELETE_COMMISSION = gql`
  mutation deleteCommission($id: Int!) {
    deleteCommission(id: $id) 
  }
  `;
